var BadgeVariant;
(function (BadgeVariant) {
    BadgeVariant["PILL"] = "pill";
    BadgeVariant["NOTIFICATION"] = "notification";
    BadgeVariant["ORDER"] = "order";
    BadgeVariant["DOT"] = "dot";
})(BadgeVariant || (BadgeVariant = {}));

export { BadgeVariant as B };
